import { BffOverlay } from "vmd-types";

import { STRAPI_URL } from "../env";
import { appQueryClient, fetchWithCache } from "./query-cache";

export async function fetchOverlay(): Promise<BffOverlay> {
  return fetchWithCache({
    queryKey: ["overlay"],
    staleTime: 15 * 60 * 1000,
    fallback: appQueryClient.getQueryData<BffOverlay>(["overlay"]) ?? {
      projects: [],
    },
    queryFn: async () => {
      const response = await fetch(`${STRAPI_URL}/bff-overlay`, {
        credentials: "include",
      });

      if (response.status >= 400) {
        throw new Error(`Fetch failed with status ${response.status}.`);
      }

      return (await response.json()) as BffOverlay;
    },
  });
}
